// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bold___btxMQ{font-family:var(--boldFont)}\n", "",{"version":3,"sources":["webpack://./src/components/TwoDashes/index.css"],"names":[],"mappings":"AAAA,cACI,2BAAA","sourcesContent":[".bold {\n    font-family: var(--boldFont);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bold": "bold___btxMQ"
};
export default ___CSS_LOADER_EXPORT___;
